import { Injectable } from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  name: string;
  type?: string;
}

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

const MENUITEMS = [
  {
    state: 'dashboard',
    name: 'HOME',
    type: 'link',
    icon: 'home'
  },
  {
    state: 'contacts',
    name: 'Contacts',
    type: 'link',
    icon: 'call'
  },
  {
    state: 'product',
    name: 'Products',
    type: 'sub',
    icon: 'apps',
    children: [
      { state: 'category', name: 'Category' },
      { state: 'products', name: 'Products' },
    ]
  },
  {
    state: 'enquiry',
    name: 'Enquiries',
    type: 'link',
    icon: 'dvr'
  },
  {
    state: 'change-password',
    name: 'Setting',
    type: 'link',
    icon: 'vpn_key'
  },
  {
    state: 'subscribers',
    name: 'Subscriber',
    type: 'link',
    icon: 'supervised_user_circle'
  }
];

@Injectable()
export class MenuService {
  getAll(): Menu[] {
    return MENUITEMS;
  }

  add(menu) {
    MENUITEMS.push(menu);
  }
}
